<div class="title">
  <h2 mat-dialog-title>Filtrar histórico</h2>
  <div class="title-left">
    <button
      mat-stroked-button
      class="rounded"
      aria-label="Clear"
      [disabled]="!dirty"
      (click)="clear()"
    >
      Limpar filtros
    </button>
    <button mat-dialog-close mat-icon-button aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<div mat-dialog-content>
  <div class="category" *ngFor="let cat of category">
    <div class="category-title">{{ cat.name }}</div>
    <div class="list">
      <mat-selection-list
        [multiple]="false"
        (selectionChange)="handleSelect($event, cat.name)"
      >
        <mat-radio-group>
          <mat-list-option
            *ngFor="let opt of cat.options"
            [value]="opt.value"
            [selected]="opt.selected"
          >
            <div class="option-item">
              {{ opt.name }}
              <mat-radio-button
                color="primary"
                [value]="opt.value"
                [checked]="opt.selected"
              ></mat-radio-button>
            </div>
            <mat-divider></mat-divider>
          </mat-list-option>
        </mat-radio-group>
      </mat-selection-list>
    </div>
  </div>
</div>
<mat-dialog-actions align="end">
  <button
    mat-button
    mat-flat-button
    cdkFocusInitial
    color="primary"
    class="rounded"
    [disabled]="!dirty"
    (click)="apply()"
  >
    Aplicar filtros
  </button>
</mat-dialog-actions>
